var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copied",class:{
    'copied--show': _vm.visible,
    'copied--hide': _vm.hide,
  }},[_vm._v("\n  "+_vm._s(_vm.$t('copied.label'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }